import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/RegisterPage.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/HomePage.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/DashboardPage.vue')
      },
      {
        path: '/activity-list',
        name: 'ActivityList',
        component: () => import('../views/ActivityListPage.vue')
      },
      {
        path: '/activity-detail/:id',
        name: 'ActivityDetail',
        component: () => import('../views/ActivityDetailPage.vue')
      },
      {
        path: '/activity-publish',
        name: 'ActivityPublish',
        component: () => import('../views/ActivityPublishPage.vue'),
        meta: { requiresOrganizer: true }
      },
      {
        path: '/activity-edit/:id',
        name: 'ActivityEdit',
        component: () => import('../views/ActivityEditPage.vue'),
        meta: { requiresOrganizer: true }
      },
      {
        path: '/activity-manage',
        name: 'ActivityManage',
        component: () => import('../views/ActivityManagePage.vue'),
        meta: { requiresOrganizer: true }
      },
      {
        path: '/user-center',
        name: 'UserCenter',
        component: () => import('../views/UserCenterPage.vue')
      },
      {
        path: '/admin',
        name: 'Admin',
        component: () => import('../views/AdminPage.vue'),
        meta: { requiresAdmin: true }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router 